import { render } from "./App.vue?vue&type=template&id=c7accbd2"
const script = {}

import "./App.vue?vue&type=style&index=0&id=c7accbd2&lang=css"
script.render = render

export default script